import React from 'react';
import { ArrowRight, Play, Users, TrendingUp, Shield } from 'lucide-react';

const Hero = () => {
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section id="hero" className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-teal-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                                <TrendingUp className="w-4 h-4 mr-2" />
                                Trusted by 500+ Finance Offices
                            </div>
                            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight">
                                Transform Your
                                <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent"> Finance Office</span>
                                <br />
                                with Smart Solutions
                            </h1>
                            <p className="text-xl text-gray-600 leading-relaxed">
                                We create powerful apps and websites that streamline operations, enhance client relationships, and drive growth for small to mid-sized finance offices.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={() => scrollToSection('contact')}
                                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center group"
                            >
                                Get Started Today
                                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </button>
                            <button
                                onClick={() => scrollToSection('products')}
                                className="border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-lg font-semibold hover:border-blue-600 hover:text-blue-600 transition-all duration-300 flex items-center justify-center group"
                            >
                                <Play className="mr-2 w-5 h-5 group-hover:scale-110 transition-transform" />
                                View Our Work
                            </button>
                        </div>

                        <div className="grid grid-cols-3 gap-8 pt-8">
                            <div className="text-center">
                                <div className="text-3xl font-bold text-blue-600">500+</div>
                                <div className="text-sm text-gray-600">Happy Clients</div>
                            </div>
                            <div className="text-center">
                                <div className="text-3xl font-bold text-teal-600">95%</div>
                                <div className="text-sm text-gray-600">Client Retention</div>
                            </div>
                            <div className="text-center">
                                <div className="text-3xl font-bold text-orange-600">24/7</div>
                                <div className="text-sm text-gray-600">Support</div>
                            </div>
                        </div>
                    </div>

                    <div className="relative">
                        <div className="bg-gradient-to-r from-blue-100 to-teal-100 rounded-2xl p-8 transform rotate-3 hover:rotate-0 transition-transform duration-500">
                            <div className="bg-white rounded-xl shadow-2xl p-6 transform -rotate-3 hover:rotate-0 transition-transform duration-500">
                                <div className="space-y-4">
                                    <div className="flex items-center justify-between">
                                        <h3 className="text-lg font-semibold text-gray-900">Client Dashboard</h3>
                                        <div className="flex space-x-2">
                                            <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                                            <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                                        </div>
                                    </div>
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-3">
                                            <Users className="w-5 h-5 text-blue-600" />
                                            <div className="flex-1 bg-gray-100 rounded-full h-2">
                                                <div className="bg-blue-600 h-2 rounded-full w-3/4"></div>
                                            </div>
                                            <span className="text-sm text-gray-600">75%</span>
                                        </div>
                                        <div className="flex items-center space-x-3">
                                            <TrendingUp className="w-5 h-5 text-teal-600" />
                                            <div className="flex-1 bg-gray-100 rounded-full h-2">
                                                <div className="bg-teal-600 h-2 rounded-full w-5/6"></div>
                                            </div>
                                            <span className="text-sm text-gray-600">85%</span>
                                        </div>
                                        <div className="flex items-center space-x-3">
                                            <Shield className="w-5 h-5 text-orange-600" />
                                            <div className="flex-1 bg-gray-100 rounded-full h-2">
                                                <div className="bg-orange-600 h-2 rounded-full w-full"></div>
                                            </div>
                                            <span className="text-sm text-gray-600">100%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;